var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlexibleHandover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 70 70",
    viewBox: "0 0 70 70",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m62.51 9.03v19.66c0 3.33-2.71 6.04-6.04 6.04h-22.96c-3.33 0-6.04-2.71-6.04-6.04v-19.66c.01-3.33 2.71-6.03 6.04-6.03h22.96c3.33 0 6.04 2.7 6.04 6.03z",
    fill: "#f9a41a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m66.96 13.48v19.66c0 3.33-2.71 6.04-6.04 6.04h-22.95c-3.33 0-6.04-2.71-6.04-6.04v-19.66c0-3.33 2.71-6.03 6.04-6.03h22.96c3.32 0 6.03 2.7 6.03 6.03z",
    fill: "#fbe063"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m54.18 7.45v4.27c0 1.26-1.02 2.28-2.28 2.28h-4.92c-1.26 0-2.28-1.02-2.28-2.28v-4.27z",
    fill: "#495e66"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m43.25 33.28h-5.76c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h5.76c.28 0 .5.22.5.5s-.22.5-.5.5z",
    fill: "#f9a41a"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m47.15 29.56h-9.67c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h9.67c.28 0 .5.22.5.5s-.22.5-.5.5z",
    fill: "#f9a41a"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m65.96 48.92c0 1.15-.62 2.21-1.63 2.78 0 0-20.87 14.82-29.25 15.29-5.44.31-20.06-8.49-20.06-8.49v-15.68s4.7-.13 10.23 0c4 .09 8.33 2.12 11.65 5.12h7.46c1.8 0 3.25 1.45 3.25 3.25 0 .65-.19 1.25-.51 1.75v.01l1.89-.91 12.39-5.99c2.12-1.02 4.58.52 4.58 2.87z",
    fill: "#ffc6cd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m48.99 52.04c-.7 1.66-2.68 3-4.29 3h-14.4c-.28 0-.5-.22-.5-.5 0-.27.22-.5.5-.5h14.4c.8 0 1.7-.45 2.39-1.09h.01z",
    fill: "#ffaecd"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m15.09 42.06v18.72c0 1.21-.98 2.2-2.2 2.2h-7.65c-1.22 0-2.2-.99-2.2-2.2v-18.72c0-1.22.98-2.2 2.2-2.2h7.65c1.22 0 2.2.98 2.2 2.2z",
    fill: "#8f90fb"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 10.96,
    cy: 58.25,
    fill: "#fff",
    r: 1.75
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlexibleHandover);
export default __webpack_public_path__ + "static/media/flexible-handover.951fab4846ba0a1b0af93450b078fd4d.svg";
export { ForwardRef as ReactComponent };